// extracted by mini-css-extract-plugin
export default {"placeholder":"Blog_placeholder__JTIsV","icon":"Blog_icon__UqBRR","comingSoon":"Blog_comingSoon__93Tx1","desc":"Blog_desc__K-POX"};